import colors from "../foundations/colors";

const Link = {
	baseStyle: {
		color: colors.lightBlue,
	},
};

export default Link;
